type EventHandler = (...args: any[]) => void;

/** The shape this mixin grafts onto whatever object spreads it in. */
export interface EventEmitter {
  _eventHandlers?: Record<string, EventHandler[]>;
  on(eventName: string, handler: EventHandler): void;
  off(eventName: string, handler: EventHandler): void;
  trigger(eventName: string, ...args: unknown[]): void;
}

const eventMixin: EventEmitter = {

  /**
   * Subscribe to event, usage:
   *  menu.on('select', function(item) { ... }
   **/
  on(eventName, handler) {
    if (!this._eventHandlers) this._eventHandlers = {};
    if (!this._eventHandlers[eventName]) {
      this._eventHandlers[eventName] = [];
    }
    this._eventHandlers[eventName].push(handler);
  },

  /**
   * Cancel the subscription, usage:
   *  menu.off('select', handler)
   **/
  off(eventName, handler) {
    let handlers = this._eventHandlers?.[eventName];
    if (!handlers) return;
    for (let i = 0; i < handlers.length; i++) {
      if (handlers[i] === handler) {
        handlers.splice(i--, 1);
      }
    }
  },

  /**
   * Generate an event with the given name and data
   *  this.trigger('select', data1, data2);
   **/
  trigger(eventName, ...args) {
    const handlers = this._eventHandlers?.[eventName];
    if (!handlers) {
      return; // no handlers for that event name
    }

    // call the handlers
    handlers.forEach(handler => handler.apply(this, args));
  }

};

export default eventMixin;
